import { useState, useEffect } from 'react';
import { SpreadsheetSchema } from '../../types';
import useCountryAxiosInstance from "../../../hooks/useCountryAxiosInstance";

export const useSpreadsheets = () => {
  const [spreadsheets, setSpreadsheets] = useState<SpreadsheetSchema[]>();
  const [loading, setLoading] = useState(false);
  const countryApiRequest = useCountryAxiosInstance();
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await countryApiRequest.get("/google_sheets/spreadsheets");
        setSpreadsheets(response)
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();

  }, []);

  return {spreadsheets, loading};
}